import { motion } from 'framer-motion';
import Container from './Container';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';
import { approach } from '@/lib/content';

export default function Approach() {
  return (
    <section
      id="approach"
      aria-labelledby="approach-heading"
      className="relative border-y border-ink/10 bg-ink text-paper py-24 md:py-36"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            'linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)',
          backgroundSize: '64px 64px',
        }}
      />

      <Container className="relative">
        <div className="max-w-3xl">
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            className="eyebrow mb-5 text-paper/60"
          >
            Approach
          </motion.div>
          <motion.h2
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            id="approach-heading"
            className="text-balance text-4xl leading-[1.05] text-paper md:text-5xl lg:text-[3.5rem]"
          >
            Clarify the opportunity. Design the right system. Execute with discipline.
          </motion.h2>
          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            className="mt-6 max-w-2xl text-pretty text-base leading-relaxed text-paper/70 md:text-lg"
          >
            A working style that favors senior judgment over ceremony. We scope carefully, move
            quickly once the problem is clear, and leave our clients more capable than we found
            them.
          </motion.p>
        </div>

        <motion.ol
          variants={stagger(0.1, 0.1)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-16 grid grid-cols-1 gap-10 md:mt-20 md:grid-cols-3 md:gap-12"
        >
          {approach.map((step) => (
            <motion.li
              key={step.step}
              variants={fadeUp}
              className="relative border-t border-paper/15 pt-8"
            >
              <div className="flex items-baseline justify-between">
                <span className="font-mono text-xs tracking-[0.2em] text-paper/50">
                  {step.step}
                </span>
              </div>
              <h3 className="mt-4 font-display text-2xl text-paper md:text-[1.75rem]">
                {step.title}
              </h3>
              <p className="mt-4 max-w-sm text-[15px] leading-relaxed text-paper/70">
                {step.body}
              </p>
            </motion.li>
          ))}
        </motion.ol>
      </Container>
    </section>
  );
}
